import type { App } from 'vue';
import mitt from 'mitt';
// import useFormModal from '@/hooks/useFormModal'
// import useModal from '@/hooks/useModal/index';
/**
 * 注册全局方法
 * @param app
 */
//创建Mitt实例
const Mit = mitt();
export function setupGlobalMethods(app: App) {
  // if (import.meta.env.VITE_ENV !== "development") {
  //   DisableDevtool({
  //     ondevtoolclose: () => {
  //       window.location.href = 'https://web.nusatrip.sg';
  //     },
  //     timeOutUrl: 'https://web.nusatrip.sg',
  //     md5: ''
  //   });
  // }
  // app.config.globalProperties.$Cid = channelCid;
  // 全局挂载Reflect反射对象,以便在vue模板中使用
  app.config.globalProperties.Reflect = Reflect;
  // 全局常用eventBus方法
  app.config.globalProperties.$Bus = Mit;
}
